import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Collapse } from "@mui/material";

import ServerRowHeader from "./ServerRowComponents/ServerRowHeader";
import {
  SecurityCol,
  ResourceCol,
  AppCol,
} from "./ServerRowComponents/ServerColumns";
import SslDomainModal from "./ServerRowComponents/SslDomainModal";
import SqlExplorerModal from "./ServerRowComponents/SqlExplorerModal";

// DİKKAT: onEdit props olarak buraya eklendi
export default function ServerRow({ server, onEdit }) {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
  const [domainModalOpen, setDomainModalOpen] = useState(false);
  const [sqlModalOpen, setSqlModalOpen] = useState(false);

  let stats = {
    ram_total: 0,
    ram_used: 0,
    ram_percent: 0,
    cpu_percent: 0,
    disk_total: 0,
    disk_used: 0,
    disk_percent: 0,
    net_rx: 0,
    net_tx: 0,
    uptime: "Bekleniyor...",
    top_ips: [],
    top_procs: [],
    services: [],
    ssh_fails: [],
    ssl_reports: [],
    pm2_apps: [],
    last_check: null,
  };

  try {
    if (server.last_status) {
      stats =
        typeof server.last_status === "string"
          ? JSON.parse(server.last_status)
          : server.last_status;
    }
  } catch (e) {}

  const isOffline = stats.last_check
    ? new Date() - new Date(stats.last_check) > 15 * 60 * 1000
    : true;
  const isPending = !stats.last_check;
  const ddosAlert =
    server.is_ddos_alert_active &&
    stats.top_ips.length > 0 &&
    stats.top_ips[0].count > 300;

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        border: isExpanded
          ? "1px solid rgba(29, 111, 242, 0.4)"
          : "1px solid rgba(234,240,248, 0.05)",
        borderRadius: 4,
        transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        overflow: "hidden",
        boxShadow: isExpanded ? "0 15px 45px -10px rgba(0,0,0,0.6)" : "none",
        "&:hover": {
          borderColor: !isExpanded && "rgba(29, 111, 242, 0.2)",
          transform: !isExpanded && "translateY(-2px)",
        },
      }}
    >
      {/* onEdit fonksiyonu Header bileşenine aktarılıyor */}
      <ServerRowHeader
        server={server}
        stats={stats}
        isExpanded={isExpanded}
        setIsExpanded={setIsExpanded}
        isOffline={isOffline}
        isPending={isPending}
        ddosAlert={ddosAlert}
        onEdit={onEdit}
      />

      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <Box
          sx={{
            p: { xs: 3, sm: 4 },
            bgcolor: "rgba(0,0,0,0.15)",
            borderTop: "1px solid rgba(234,240,248,0.05)",
          }}
        >
          <Grid container spacing={4}>
            <SecurityCol
              stats={stats}
              setDomainModalOpen={setDomainModalOpen}
            />
            <ResourceCol stats={stats} />
            <AppCol
              stats={stats}
              server={server}
              navigate={navigate}
              setSqlModalOpen={setSqlModalOpen}
            />
          </Grid>
        </Box>
      </Collapse>

      <SslDomainModal
        open={domainModalOpen}
        onClose={() => setDomainModalOpen(false)}
        server={server}
      />
      <SqlExplorerModal
        open={sqlModalOpen}
        onClose={() => setSqlModalOpen(false)}
        server={server}
      />
    </Box>
  );
}
